import { motion, AnimatePresence } from "framer-motion";
import { Paperclip } from "lucide-react";

/**
 * Gold dashed-border overlay that appears when a user drags a file over
 * the ARIA chat panel. Pointer events disabled so the underlying panel
 * still receives the drop event.
 */
export default function DropOverlay({ active }) {
  return (
    <AnimatePresence>
      {active && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 z-[10] flex items-center justify-center bg-black/85 border-2 border-dashed border-gold pointer-events-none"
          data-testid="aria-drop-overlay"
        >
          <div className="text-center px-6">
            <Paperclip size={32} className="text-gold mx-auto mb-3" />
            <p className="text-gold text-sm font-body uppercase tracking-[0.18em] mb-1">Drop to share</p>
            <p className="text-white/50 text-[11px] font-body">JPG · PNG · WebP · PDF · TXT · CSV · MD · up to 10 MB</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
